import moment from 'moment';
import {
  lastFourSSNRegex, licenseNumberRegex, firstLastNameRegex
} from 'utility/regex';

export const MqaCheckValidatorFactory = (showRegistrationCheck: boolean, newPhysicianRegistration: boolean = false) => {
  // Returns a function that is passed to anything that must validate an instance of MqaCheckValidatorFactory

  return (values) => {
    const validators = {
      requiredProfession: (values.profession ? '' : 'Professional Code is required'),
      requiredLicenseNumber: (values.licenseNumber ? '' : 'License Number is required'),
      requiredJustification: (newPhysicianRegistration || values.justification ? '' : 'Justification is required'),
      formatLicenseNumber: (values.licenseNumber ? (licenseNumberRegex.test(values.licenseNumber) ? '' : 'License number not in correct format') : ''),
      requiredFirstName: '',
      requiredLastName: '',
      requiredDOB: '',
      requiredLastFourSSN: '',
      formatFirstName: '',
      formatLastName: '',
      formatDOB: '',
      formatLastFourSSN: ''
    };

    if (showRegistrationCheck) {
      validators.requiredFirstName = (values.firstName ? '' : 'First Name is required');
      validators.requiredLastName = (values.lastName ? '' : 'Last Name is required');
      validators.requiredDOB = (values.dob ? '' : 'Date of Birth is required');
      validators.requiredLastFourSSN = (values.lastFourSSN ? '' : 'Last Four Digits of SSN is required');
      validators.formatFirstName = (values.firstName ? (firstLastNameRegex.test(values.firstName) ? '' : 'First name is not in correct format') : '');
      validators.formatLastName = (values.lastName ? (firstLastNameRegex.test(values.lastName) ? '' : 'Last name is not in correct format') : '');
      validators.formatDOB = (values.dob ? (new Date(values.dob).getFullYear() >= 1900 && moment(values.dob).toDate() < moment().toDate() ? '' : 'Enter a valid Date of Birth') : '');
      validators.formatLastFourSSN = (values.lastFourSSN ? (lastFourSSNRegex.test(values.lastFourSSN) ? '' : 'Last four SSN is not in correct format') : '');
    }

    return validators;
  };
};
